import React from 'react';

function Banner(){
    return (
        <div id="banner">
            <div className="banner-container wrapper">
                <img src="assets/designs/leon-banner-responsive.png" alt="Leon Hsu Banner"></img>
            </div>
        </div>        
    )
}

export default Banner;